import { render, staticRenderFns } from "./settings-personal-details-form.vue?vue&type=template&id=326d25b4&scoped=true&"
import script from "./settings-personal-details-form.vue?vue&type=script&lang=js&"
export * from "./settings-personal-details-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d25b4",
  null
  
)

export default component.exports